import api from "@/lib/api";

export const orgLibraryService = {
  library: () => api.get("/org/library").then((r) => r.data),
  compliance: () => api.get("/org/compliance").then((r) => r.data.courses),
  memberCertificate: async (courseId, memberId, name) => {
    const res = await api.get(`/org/library/${courseId}/certificate/${memberId}`, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `certificate-${(name || memberId).replace(/[^a-z0-9]+/gi, "-")}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
  setVisibility: ({ id, visibility, team_ids, member_ids }) =>
    api.put(`/org/library/${id}/visibility`, { visibility, team_ids, member_ids }).then((r) => r.data.course),
  setCourseType: ({ id, course_type }) =>
    api.put(`/org/library/${id}/type`, { course_type }).then((r) => r.data),
  deleteCourse: (id) => api.delete(`/org/library/${id}`).then((r) => r.data),

  teams: () => api.get("/org/teams").then((r) => r.data.teams),
  createTeam: (name) => api.post("/org/teams", { name }).then((r) => r.data.team),
  renameTeam: ({ id, name }) => api.put(`/org/teams/${id}`, { name }).then((r) => r.data),
  deleteTeam: (id) => api.delete(`/org/teams/${id}`).then((r) => r.data),
  addTeamMember: ({ teamId, memberId }) => api.post(`/org/teams/${teamId}/members`, { member_id: memberId }).then((r) => r.data),
  removeTeamMember: ({ teamId, memberId }) => api.delete(`/org/teams/${teamId}/members/${memberId}`).then((r) => r.data),
};
